import React, { useMemo } from "react";
// import AppCard from "@/components/Common/appCard";
// import { Button } from "@/components/Common/button";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Text } from "lucide-react";
import { Globe2, Pencil } from "lucide-react";
// import { getLabel, toDateOnly, visitProject } from "@/utilities/functions/common";
// import { GHG_REPORT_PURPOSE } from "@/utilities/constants/options.constants";
import { useTranslation } from "react-i18next";
import { calculateNxmapProgress } from "@/features/onboarding/utils";
import {
  toDateOnly,
  getLabel,
  visitProject,
  GHG_REPORT_PURPOSE,
} from "@/features/onboarding/utils";

const NXMapCard = ({ baseYear, organizationBoundary, data = {}, onOpen }) => {
  const { t } = useTranslation();
  const notSetLabel = t("Not set");

  const progressData = {
    ...data,
    baseYear: baseYear,
    organizationBoundary: organizationBoundary,
  };

  const progress = useMemo(
    () => calculateNxmapProgress(progressData),
    [progressData],
  );
  const purposeLabel = useMemo(() => {
    const label = getLabel(data.ghgReportPurpose, GHG_REPORT_PURPOSE);
    return label ? t(label) : notSetLabel;
  }, [data.ghgReportPurpose, notSetLabel, t]);
  const thresholdValue = data.threshold ?? notSetLabel;
  const periodStart = toDateOnly(data.baseYearStart) || notSetLabel;
  const periodEnd = toDateOnly(data.baseYearEnd) || notSetLabel;

  const progressFooter = (
    <div className="flex items-center gap-3">
      <div className="h-1.5 w-full flex-1 overflow-hidden rounded-full bg-gradient-to-r from-emerald-400/20 to-blue-500/20">
        <div
          className="h-full bg-gradient-to-r from-emerald-400 to-blue-500 transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );

  return (
    // <AppCard
    //   className="overflow-hidden lg:col-span-1"
    //   title={t('NXMap - Reporting Configuration')}
    //   icon={Globe2}
    //   actions={
    //     <>
    //       <Text variant="value" className="hidden sm:inline">
    //         {progress}%
    //       </Text>
    //       <Button
    //         size="sm"
    //         variant="nxStartBlue"
    //         className="transition-transform duration-200 hover:-translate-y-0.5"
    //         onClick={() => onOpen('nxmap', data)}
    //       >
    //         <Pencil className="!h-3 !w-3" />
    //         <span className="hidden sm:inline">{t('Edit Info')}</span>
    //       </Button>
    //       <Button
    //         size="sm"
    //         variant="nxStartOrigin"
    //         className="transition-transform duration-200 hover:-translate-y-0.5"
    //         onClick={() => visitProject('nxmap')}
    //         // onClick={() => {
    //         //   if (typeof window !== 'undefined') {
    //         //     const win = window.open(
    //         //       'https://nxmapstg.evercomm.com.sg/login',
    //         //       '_blank',
    //         //       'noopener,noreferrer',
    //         //     );
    //         //     if (win) win.opener = null;
    //         //   }
    //         // }}
    //       >
    //         {t('Visit NXMap')}
    //       </Button>
    //     </>
    //   }
    //   progress={progress}
    // >
    //   <div className="my-5 grid grid-cols-1 gap-4 md:grid-cols-2">
    //     <div className="rounded-xl border p-3 dark:border-white/20">
    //       <div className="flex items-center justify-between py-1">
    //         <Text variant="label">{t('Purpose')}</Text>
    //         <Text variant="value">{purposeLabel}</Text>
    //       </div>
    //       <div className="flex items-center justify-between py-1">
    //         <Text variant="label">{t('Threshold')}</Text>
    //         <Text variant="value">{thresholdValue}</Text>
    //       </div>
    //     </div>
    //     <div className="rounded-xl border p-3 dark:border-white/20">
    //       <div className="flex items-center justify-between py-1">
    //         <Text variant="label">{t('Period Start')}</Text>
    //         <Text variant="value">{periodStart}</Text>
    //       </div>
    //       <div className="flex items-center justify-between py-1">
    //         <Text variant="label">{t('Period End')}</Text>
    //         <Text variant="value">{periodEnd}</Text>
    //       </div>
    //     </div>
    //   </div>
    // </AppCard>
    <Card className="rounded-radius pt-0">
      <CardHeader className="rounded-t-lg grid gap-2 py-3 bg-gradient-to-br from-slate-100 to-white dark:from-white/10 dark:to-white/5">
        <div className="flex items-center justify-between gap-2">
          <CardTitle className="flex justify-between items-center gap-2 text-base text-primary">
            <Globe2 size={20} />
            {t("NXMap - Reporting Configuration")}
          </CardTitle>

          <div className="text-base text-primary flex items-center gap-3">
            <span className="text-sm font-semibold text-foreground">
              {progress}%
            </span>
            <Button
              size="sm"
              variant="secondary"
              className="bg-primary text-white hover:bg-primary/90 dark:bg-primary dark:hover:bg-primary/90"
              // className="transition-transform duration-200 hover:-translate-y-0.5"
              onClick={() => onOpen("nxmap", data)}
            >
              <Pencil className="!h-3 !w-3" />
              <span className="hidden sm:inline">{t("Edit Info")}</span>
            </Button>
            <Button
              size="sm"
              variant="secondary"
              disabled
              className="bg-nxstart-origin text-white hover:bg-nxstart-origin/90 dark:bg-nxstart-origin dark:hover:bg-nxstart-origin/90"
              // onClick={() => visitProject("nxmap")}
            >
              {t("Visit NXMap")}
            </Button>
          </div>
        </div>
        {progressFooter}
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid gap-3 sm:grid-cols-2">
          <div className="rounded-xl border text-sm p-3 dark:border-white/20">
            <div className="flex justify-between items-center mb-2">
              <p className="text-muted-foreground">{t("Purpose")}</p>
              <p>{purposeLabel}</p>
            </div>
            <div className="flex justify-between items-center">
              <p className="text-muted-foreground">{t("Threshold")}</p>
              <p>{thresholdValue}</p>
            </div>
          </div>
          <div className="rounded-xl border text-sm p-3 dark:border-white/20">
            <div className="flex justify-between items-center mb-2">
              <p className="text-muted-foreground">{t("Period Start")}</p>
              <p>{periodStart}</p>
            </div>
            <div className="flex justify-between items-center">
              <p className="text-muted-foreground">{t("Period End")}</p>
              <p>{periodEnd}</p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default NXMapCard;
